<template>
  <div class="item">
    <div class="left">
      <div class="icon">￥</div>
      <div class="text" >
        <div class="label">饭卡余额</div>
        <div class="main"> {{text}} </div>
      </div>
    </div>
    <div class="right" @click="$emit('charge')">
      <div class="area">
        <div class="icon">充</div>
        <div class="button" @click="$emit('click')">充值</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'
.item
  background white
  height pt(135)
  width 750px
  depth(1)
  display block
  position relative
  .left
    width 375px
    padding-left pt(60)
    display inline-block
    height pt(135)
    position relative
    .icon
      background #ff5d96
      border-radius 50%
      width pt(48)
      height pt(48)
      display inline-block
      text-align center
      line-height pt(48)
      color white
      position absolute
      top 50%
      transform translate(0,-50%)
    .text
      display inline-block
      padding-left pt(76)
      .label
        font-size $small-font-size
        color $second-text-color
        padding pt(20) 0 pt(8)
        text-align left
        single-line()
      .main
        font-size $big-font-size
        color $hightlint-text-color
        padding 0
        text-align left
        single-line()
  .right
    width 375px
    height pt(135)
    padding-right pt(60)
    display inline-block
    position absolute
    &::before
      content ""
      display block
      position relative
      width 1px
      height pt(64)
      top pt(37)
      border-left 1px solid $divide-line-color
    .area
      width pt(220)
      height pt(48)
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      .icon
        width pt(48)
        height pt(48)
        display inline-block
        border-radius 50%
        background $secondy-color
        color white
        text-align center
        line-height pt(48)
      .button
        width pt(140)
        height pt(48)
        margin-left pt(20)
        border-radius pt(24)
        margin-top pt(1)
        border 1px solid #97e4b7
        color $primary-color
        font-size $normal-font-size
        display inline-block
        text-align center
</style>




// WEBPACK FOOTER //
// charge.vue?3a059b01